import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import { BENEFICIARY_OPTION_MENUS } from '../Layout/menu-names'
import { useSelector } from 'react-redux'
import { getMenuListSelector } from '../../store/selectors/app.selector'
import { ADD_BENEFICIARY_KEYS } from '../../utils/translation-constants'

export default function BeneficiaryOption() {
  const history = useHistory()
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['ADD'] || {}

  return (
    <LayoutWithAccountCard breadCumKey='ADD_BENE'>
      <div className='heading-style1'>{t(ADD_BENEFICIARY_KEYS.ADD_BENEFICIARY_HEADER)}</div>
      <Row>
        {Object.keys(menuConfig).length>0 && BENEFICIARY_OPTION_MENUS.map((option, index) => (
          <>
          {menuConfig[option.key] && (
          <Col
            onClick={() => history.push(option.link)}
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'>
            <img width={52} height={40} src={option.icon} />
            <h2>{t(option.title)}</h2>
            <span>{t(option.desc)}</span>
          </Col>
          )}
          </>
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
